// extracted by mini-css-extract-plugin
export default {"dashedButton":"SharedEmptyPicker-module__dashedButton__gzG8iks","hotkeyBadge":"SharedEmptyPicker-module__hotkeyBadge__dk2CxOr"};